const header = {
    autoCloseOffCanvasMenu() {
        if (991 < window.innerWidth) {
            this.closeOffCanvasMenu();
        }
    },
    closeOffCanvasMenu() {
        header.locals.OFF_CANVAS_MENU.hide();
    },
	locals: {
        OFF_CANVAS_CART_DRAWER: null,
		OFF_CANVAS_MENU: null,
		scroll: {
			CURRENT: 0,
			INITIAL: !0,
			START: 0
		},
        search: {
            CLASS_LIST: "",
            CLOSE: document.getElementById("hdr-searchCloseButton"),
            ELEMENT: document.getElementById("hdr-search"),
            HIDE: $(".header__hide-search"),
            INPUT: $("#hdr-searchInput"),
            OPEN: document.getElementById("hdr-searchIcon"),
            WRAPPER: document.getElementById("hdr-search"),
        }
	},
	reset(clear) {
        $("#hdr-predictiveResults").html("").hide();
        header.locals.search.INPUT.val("");
        if (clear) {
            return;
        }
        header.locals.search.ELEMENT.style.cssText = header.locals.search.CLASS_LIST;
        header.locals.search.HIDE.css("display", "block");
	},
	setHandlers() {
        document.getElementById("hdr-cartIcon").addEventListener("click", function() {
            if ("false" === this.dataset.drawer) {
                window.location = this.dataset.href;
                return;
            }
            document.dispatchEvent(new CustomEvent("cart:drawer"));
        });
        document.getElementById("hdr-searchButton").addEventListener("click", e => {
            e.preventDefault();
            document.getElementById("hdr-formSearch").submit();
        });
        document.getElementById("offcanvasMenu").addEventListener("show.bs.offcanvas", () => {
            document.querySelector(".offcanvas-menu-open").style.display = "none";
            document.querySelector(".offcanvas-menu-close").style.display = "block";
            document.querySelector("body").style.overflowY = "hidden";
        });
        document.getElementById("offcanvasMenu").addEventListener("hide.bs.offcanvas", () => {
            document.querySelector(".offcanvas-menu-open").style.display = "block";
            document.querySelector(".offcanvas-menu-close").style.display = "none";
            document.querySelector("body").style.overflowY = "scroll";
        });
        document.addEventListener("pointerdown", e => {
            const path = e.composedPath();
            if (!path.includes(header.locals.search.WRAPPER)) {
                header.reset();
            }
        });
        header.locals.search.CLOSE.addEventListener("click", () => {
            header.reset();
        });
        header.locals.search.INPUT.on("keyup", function () {
            if (!this.value.length) {
                header.reset(true);
            }
            if (3 <= this.value.length) {
                $.get(`/search/suggest?q=${encodeURIComponent(this.value)}&options[prefix]=last&resources[type]=product&resources[options][unavailable_products]=hide&
                    resources[options][fields]=title,product_type,tag&section_id=search__predictive`,
                    (r) => {
                        $("#hdr-predictiveResults").html(r).show();
                        $("#hdr-predictiveResultsParam").html(this.value);
                    }
                );
            }
        });
        header.locals.search.OPEN.addEventListener("click", e => {
            header.locals.search.HIDE.css("display", "none");
            header.locals.search.CLASS_LIST = header.locals.search.ELEMENT.style.cssText;
            const topBarHeight = document.getElementById("hdr-topBar").offsetHeight + 10;
            header.locals.search.ELEMENT.style.cssText = `display: flex;left: 0px;padding: 0 5px;position: absolute;top: ${topBarHeight}px;width: 100%;z-index: 5`;
            header.locals.search.ELEMENT.querySelector("input")?.focus();
        });
	},
    setHeaderHeight() {
        const header = document.querySelector("header");
        if (!header) return;
        const height = header.getBoundingClientRect().height;
        document.documentElement.style.setProperty(
            "--header-height",
            `${height - 1}px`
        );
    },
    start() {
        const offcanvasCartDrawer = document.getElementById("offcanvasCartDrawer");
        if (offcanvasCartDrawer) {
            this.locals.OFF_CANVAS_CART_DRAWER = new bootstrap.Offcanvas("#offcanvasCartDrawer");
        }
        this.locals.OFF_CANVAS_MENU = new bootstrap.Offcanvas("#offcanvasMenu");
        this.locals.scroll.START = 0;
        this.setHandlers();
        requestAnimationFrame(() => {
            this.setHeaderHeight();
        });
    },
};
$(() => {
    header.start();
});
let last_width = window.innerWidth;
$(window).on("resize", function() {
    const current_width = window.innerWidth;
    if (current_width === last_width) {
        return;
    }
    last_width = current_width;
    header.autoCloseOffCanvasMenu();
    header.reset();
});
